import { createFileRoute } from '@tanstack/react-router'
import { MessageSquarePlusIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useThreads } from '@/api/hooks/useThreads'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import { EmptyState } from '@/components/molecules/empty-state'
import PageHeader from '@/components/molecules/page-header'
import { PlayVideoButton } from '@/components/molecules/play-video-button'
import ThreadsTable from '@/components/organisms/threads-table'
import { Button } from '@/components/ui/button'
import { CONVERSATIONS_VIDEO } from '@/config/videos'
import { useIndividuals } from '@/hooks/useIndividuals'
import { useAppDispatch } from '@/redux/hooks'
import { AssistantActions } from '@/redux/reducers/assistant'

const ConversationsPage = () => {
  const { individualQuery, selectedIndividual, selectedIndividualId } = useIndividuals()
  const { data: threads = [] } = useThreads(selectedIndividualId)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const onClickNewConversation = () => {
    dispatch(AssistantActions.setActiveThreadId(undefined))
    dispatch(AssistantActions.toggleSideChat(true))
  }

  return (
    <div className="space-y-8 z-10">
      <PageHeader
        body={t('conversationsPage.header.description')}
        heading={t('conversationsPage.header.title')}
        titleAction={
          <PlayVideoButton
            titleKey={CONVERSATIONS_VIDEO.titleKey}
            youtubeId={CONVERSATIONS_VIDEO.youtubeId}
          />
        }
      >
        {threads.length > 0 && (
          <Button onClick={onClickNewConversation}>
            <MessageSquarePlusIcon />
            {t('conversationsPage.header.openChatButton')}
          </Button>
        )}
      </PageHeader>
      <StateSwitcher
        emptyState={
          <EmptyState
            body={t('conversationsPage.emptyState.description', {
              individual: selectedIndividual?.firstName,
            })}
            ctaText={t('conversationsPage.header.openChatButton')}
            ctaType="create-content"
            heading={t('conversationsPage.emptyState.title')}
            onClickCta={onClickNewConversation}
          />
        }
        isEmpty={threads.length === 0}
        isLoading={individualQuery.isLoading}
      >
        <ThreadsTable threads={threads} />
      </StateSwitcher>
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/conversations')({
  component: ConversationsPage,
})
